<script setup lang="ts">
/**
 * Decorates an input with a leading / trailing icon slot.
 * Companion: `InputIcon` element renders the actual icon mark.
 */
import PrimeIconField from 'primevue/iconfield'

interface Props {
  /** Side the `InputIcon` sits on. Default `left`. */
  iconPosition?: 'left' | 'right'
}

defineProps<Props>()
</script>

<template>
  <PrimeIconField :icon-position="iconPosition">
    <slot />
  </PrimeIconField>
</template>
